import { useState, useEffect } from "react";

// Components
import TableInputValue from "@/Layouts/components/InputComponents/TableInputValue";

// MUI
import { GridRenderEditCellParams, useGridApiContext } from "@mui/x-data-grid-premium";

// Types
import { TableInputValueProps } from "@/Layouts/components/InputComponents/TableInputValue/types";
import { NumberOrString } from "@/Layouts/components/InputComponents/InputValue/types";

export function BasicNumericEditCell(
	props: Readonly<
		GridRenderEditCellParams & { inputProps?: TableInputValueProps & { acceptsEmptyValues?: boolean; inputTypeIndex?: 0 | 1 } }
	>
) {
	const { id, field, value, error, inputProps } = props;
	const apiRef = useGridApiContext();
	const [inputText, setInputText] = useState(value);
	const [typesToUseIndex, setTypesToUseIndex] = useState<0 | 1>(inputProps?.inputTypeIndex ?? 0);

	useEffect(() => {
		setTypesToUseIndex(inputProps?.inputTypeIndex ?? 0);
		setInputText(0);
		if (apiRef.current) {
			apiRef.current.state.editRows[id][field].isDirty = true;
			apiRef.current.setEditCellValue({ id, field, value: 0, debounceMs: 200 });
		}
	}, [inputProps?.inputTypeIndex]);

	const handleOnBlur = async (val: NumberOrString, input: string) => {
		await apiRef.current.setEditCellValue({ id, field, value: inputText });
		if (apiRef.current.state.editRows[id]) {
			apiRef.current.state.editRows[id][field].isDirty = false;
		}
		inputProps?.onBlur?.(val, input);
	};

	const handleOnFocus: TableInputValueProps["onClickInput"] = (...params) => {
		apiRef.current.state.editRows[id][field].isDirty = true;
		inputProps?.onClickInput?.(...params);
	};

	const isValid = !error && (inputProps?.acceptsEmptyValues ? true : Boolean(inputText));
	const inputType = inputProps?.data?.[typesToUseIndex]?.type ?? "Dollar";

	return (
		<TableInputValue
			{...inputProps}
			isControlledApi={true}
			isEditingMode={props.hasFocus}
			isRequiredOnChange={true}
			isNaNPrevented={true}
			value={{ value, input: inputType }}
			onChange={setInputText}
			error={!isValid}
			onBlur={handleOnBlur}
			onClickInput={handleOnFocus}
			sx={{
				height: "21px",
			}}
		/>
	);
}
